// Default HubSpot target for lead submissions. These are public values (the
// portal ID and form GUID ship in any HubSpot form embed and are visible in the
// bundle), so committing them here is safe and lets a Webflow page embed the
// widget with just a tagged div plus the script -- no data attributes required.
// A `data-hubspot-portal-id` / `data-hubspot-form-id` attribute (or a `mount`
// prop) overrides these for a one-off form without a rebuild; pass an empty
// string to opt out of HubSpot entirely.
export const DEFAULT_HUBSPOT_PORTAL_ID = '47302541';
export const DEFAULT_HUBSPOT_FORM_ID = '6691d4a7-faec-4901-a730-7a24ff133741';
